import xhr from "xhr";

export default async function getIdentityTypes() {
  const res = await xhr(`/identity-types`);

  return res.data.data;
}
